<template>  
  <div>
    <card card-body-classes="px-3">
      <div slot="header" class="row">
        <div class="col-6">
          <h4 class="card-title f-20-mobile">Nova Campanha</h4>
        </div>
      </div>

      <form class="row text-left" @submit="onSubmit">
        <div class="col-8 row">
          <div class="form-group col-4">
            <label>Idi (separado por vírgula)</label>
            <input type="text" v-model="data.idi" class="form-control" required>
          </div>

          <div class="form-group col-8">
            <label>Nome do Botão</label>
            <input type="text" v-model="nome" class="form-control" required>
          </div>
          <div class="form-group col-6">
            <label>Degradê início</label>
            <input type="color" v-model="degrade_inicio" class="form-control" required>
          </div>

          <div class="form-group col-6">
            <label>Degradê fim</label>
            <input type="color" disabled v-model="degrade_fim" class="form-control" required>
          </div>

          <div class="form-group col-12">
            <label>Background</label>
            <input type="text" v-model="url_imagem" class="form-control" required>
          </div>

          <div class="form-group col-12">
            <label>HTML</label>
            <textarea required v-model="html" class="form-control"></textarea>
          </div>
        </div>

        <div class="col-4 row">
          <div class="col-12">
            <p>Preview</p>
            <div class="category-item pointer" @click="openCaixaModal">
              <div class="category-banner notification" :style="{'background-image': 'url(' + url_imagem + ')'}"></div>
              <div class="category-title">{{ nome }}</div>

              <svg class="story" :style="{ 'stroke': this.degrade_inicio }">
                <circle cx="40" cy="37" r="36"/>
              </svg>
            </div>
          </div>

        </div>

        <div class="form-group col-12">
          <button class="btn btn-primary">{{ data.id ? 'Editar' : 'Salvar' }}</button>
        </div>
      </form>
    </card>
    
    <marketing-preview-modal-component></marketing-preview-modal-component>
  </div>


</template>

<script>

import axios from 'axios'
import { Card } from 'src/components'
import CampaignService from '@/services/CampaignService.js'
import MarketingPreviewModalComponent from '@/components/Modals/MarketingPreviewModalComponent.vue'

export default {
    components: {
      MarketingPreviewModalComponent,
      Card,
    },
    data() {
      return {
        data: {
          type: 'trial', 
        },
        html: null,
        nome: "Novidade!",
        degrade_inicio: '#F45B93',
        degrade_fim: '#4AC4F3',
        url_imagem: "https://cdn-adonis.s3.sa-east-1.amazonaws.com/220201218150820vQemdm4SK.png"
      }
    },
    props: [
      'user'
    ],
    methods:{
      onSubmit(e) {
        let metadata = {
          nome: this.nome,
          url_imagem: this.url_imagem,
          notification: true,
          html: this.html,
          degrade_inicio: this.degrade_inicio,
          degrade_fim: this.degrade_fim
        }

        if(this.data.idi) {
          this.data.idi = this.data.idi.split(',') 
        }

        this.data.metadata = JSON.stringify(metadata)

        e.preventDefault()

        if(this.data.id) {
          CampaignService.update(this.data).then(res => {
            this.$router.push('/campaigns/')
          })
          .catch(err => {

          })
        } else {
          CampaignService.create(this.data).then(res => {
            this.$router.push('/campaigns/')
          })
          .catch(err => {

          })
        }
      },
      openCaixaModal(caixa) {
        this.$modal.show('marketing-preview-modal-component', { html: this.html })
      },
    },
    mounted() {
    }
}
</script>

<style>

.story {
  position: absolute;
  top: 0;
  left: 0;
  fill:none;
  stroke: #F45B93;
  stroke-width: 2px;
  stroke-dasharray: 1;
  stroke-dashoffset: 0;
  stroke-linecap:round;
  animation:loading 4500ms ease-in-out infinite alternate;
}

@keyframes loading {
    100% {
      stroke:#4AC4F3;
      stroke-dasharray:10;
      transform:rotate(0deg);
  }
}


.category-item {
  position: relative;
  padding-left: 5px;
  padding-right: 5px;
  height: 80px;
  text-align: center;
  display: inline-block;
  background-size: cover;
  opacity: 1;
  padding-top: 2px;
}

.category-item.active {
  opacity: 1;
}

.category-banner.notification {
  border: 3px solid #fff !important;
}

.category-title {
  font-size: 10px;
  color: #666;
  max-width: 70px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.category-item.active .category-banner {
  border-color: #8cdaff !important;
}

.category-banner {
  background-size: cover !important;
  min-height: 70px;
  background-color: #dedede !important;
  min-width: 70px;
  margin-bottom: 5px;
  border-radius: 100%;
  border: 3px solid #ddd;
}

</style>  